import {
    Box,
    Button,
    ExternalLinkOutlined,
    Flex,
    Heading,
    Text,
} from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { token } from '@landr/styled-system/tokens';
import { Trans } from '@lingui/macro';
import React, { useCallback, useState } from 'react';

export const DisplayDeviceCodeStep: React.FC<{
    deviceAuthorizationUrl: string;
    deviceCode: string;
    onCancel: () => void;
}> = ({ deviceAuthorizationUrl, deviceCode, onCancel }) => {
    const [isWaitingForAuthentication, setIsWaitingForAuthentication] =
        useState(false);

    const openBrowser = useCallback(() => {
        window.open(deviceAuthorizationUrl, '_blank');
        setIsWaitingForAuthentication(true);
    }, [deviceAuthorizationUrl]);

    const handleCancel = useCallback(() => {
        setIsWaitingForAuthentication(false);
        onCancel();
    }, [onCancel]);

    const first3Digits = deviceCode.slice(0, 3);
    const last3Digits = deviceCode.slice(-3);

    const gradientColor = {
        '--gradientColor': token('colors.primary.900'),
    } as React.CSSProperties;

    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
        >
            <Heading textStyle="4xl" textAlign="center">
                <Trans>Authentication step</Trans>
            </Heading>
            <Text textAlign="center" color="text.medium">
                <Trans>
                    Please verify your account to use the plugin. This is the
                    temporary code to confirm in the next step.
                </Trans>
            </Text>

            <Box
                className={css({
                    border: '1px solid',
                    borderColor: 'primary.900',
                    borderRadius: 'xl',
                    background:
                        'radial-gradient(71.25% 100% at 50% 0%, var(--gradientColor) 0%, transparent 100%)',
                    mt: 'xl',
                    py: 'lg',
                    px: 'xl',
                })}
                style={gradientColor}
            >
                <Text textStyle="4xl" mr="xs">
                    {first3Digits}
                </Text>
                <Text textStyle="4xl">{last3Digits}</Text>
            </Box>

            <Button
                isRounded
                iconRight={ExternalLinkOutlined}
                onClick={openBrowser}
                isLoading={isWaitingForAuthentication}
                mt="2xl"
            >
                <Trans>Confirm via Browser</Trans>
            </Button>
            <Button
                isRounded
                kind="link"
                size="xs"
                variant="ghost"
                mt="md"
                onClick={handleCancel}
            >
                <Trans>Cancel authentication</Trans>
            </Button>
        </Flex>
    );
};
